import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '../../configuration/tokenHandling/prepareHeaders';
import type { MonitorStatisticTimeseries } from '../../domain/model/MonitorStatisticTimeseries.types';
import * as api from './generated/api';
import { toMonitorStatisticTimeseries } from './timeseries.mapper';

const baseUrl = `${import.meta.env.VITE_IOT_DATA_QUALITY_MONITOR_URL}`;

export const timeseriesApi = createApi({
    reducerPath: 'timeseriesApi',
    baseQuery: fetchBaseQuery({ baseUrl, prepareHeaders }),
    endpoints: builder => ({
        getMonitorTimeseries: builder.query<MonitorStatisticTimeseries, string>({
            query: monitorId => ({
                url: `monitors/${monitorId}/timeseries`,
            }),
            transformResponse: (response: unknown) => {
                const data = api.MonitorStatisticTimeseries.parse(response);
                return toMonitorStatisticTimeseries(data);
            },
        }),
    }),
});

export const { useGetMonitorTimeseriesQuery } = timeseriesApi;
